import React from 'react'

import ErrorIcon from '@mui/icons-material/Error'

import aampeTheme from '../../constants/aampeTheme'

import BaseAlert from '../alerts/BaseAlert'

export default function ErrorAlert({ title = 'Error' }) {
    return (
        <BaseAlert
            Icon={ErrorIcon}
            title={title}
            color={aampeTheme.colors.orange500}
            bgColor={aampeTheme.colors.error25}
        />
    )
}
